import { Input as AntInput, ConfigProvider } from 'antd';
import type { InputProps as AntInputProps } from 'antd/es/input';
import type { Dispatch, SetStateAction } from 'react';

import FieldsContainer from '../fields-container';
import { defaultInputTheme } from '../ourConfigs';

import css from './styles.module.scss';

export interface IInputProps extends AntInputProps {
  label?: string;
  onChangeValue: Dispatch<SetStateAction<string>>;
  requiredTag?: boolean;
  error?: string;
}

function Input({
  error,
  requiredTag,
  label,
  onChangeValue,
  ...props
}: IInputProps) {
  return (
    <ConfigProvider theme={defaultInputTheme}>
      <FieldsContainer error={error} requiredTag={requiredTag} label={label}>
        <AntInput
          onChange={(e) => onChangeValue(e.target.value)}
          allowClear
          status={error ? 'error' : ''}
          className={error ? css.errorBorder : ''}
          {...props}
        />
      </FieldsContainer>
    </ConfigProvider>
  );
}

export default Input;
